module.exports = __webpack_public_path__ + "static/media/icon-certified-expert.d575b3a5.svg";